import { X, Trash2 } from "react-feather";
import Icon from "@mdi/react";
import { mdiBarcodeScan } from "@mdi/js";

type Props = {
  deviceIds: string[];
  onRemoveOne: (id: string) => void;
  onClearAll: () => void;
  title?: string;
  id?: string;
};

const EditableDeviceIdsViewer: React.FC<Props> = ({
  deviceIds,
  onRemoveOne,
  onClearAll,
  title = "Allocated Device IDs",
  id,
}) => {
  if (!deviceIds.length) return null;

  return (
    <div id={id} className="border rounded-lg bg-gray-50 p-3 space-y-2">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-semibold text-amber-700">
          <Icon path={mdiBarcodeScan} size={0.7} />
          {title} ({deviceIds.length})
        </div>

        <button
          id={id ? `${id}-clear-all` : undefined}
          type="button"
          onClick={onClearAll}
          className="flex items-center gap-1 text-xs text-red-600 hover:underline"
        >
          <Trash2 size={14} />
          Clear All
        </button>
      </div>

      {/* Device Chips */}
      <div className="max-h-40 overflow-y-auto flex flex-wrap gap-2">
        {deviceIds.map((deviceId) => (
          <span
            key={deviceId}
            className="inline-flex items-center gap-1 rounded-full border bg-white px-2.5 py-0.5 text-xs font-mono"
          >
            {deviceId}
            <button
              id={id ? `${id}-remove-${deviceId}` : undefined}
              type="button"
              onClick={() => onRemoveOne(deviceId)}
              className="rounded-full hover:bg-red-100 p-0.5"
            >
              <X size={12} className="text-red-600" />
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default EditableDeviceIdsViewer;
